import React, { useContext, useState } from 'react';
import CountContext from '../../context/CountContext.js';

const DrawerCoinScreen = ({ onNext, onBack }) => {
  const { state, dispatch } = useContext(CountContext);
  // read directly from context now
  const drawerCoins = state.drawerCoins;


  const sanitize = (raw) => {
    // 1) Strip anything except digits or dot
    raw = raw.replace(/[^0-9.]/g, '');
    // 2) If multiple dots, keep only the first
    const parts = raw.split('.');
    if (parts.length > 2) {
      raw = parts[0] + '.' + parts.slice(1).join('');
    }
    // 3) If blank or just “.”, treat as “0”
    if (raw === '' || raw === '.') raw = '0';
    // 4) Parse to float
    return parseFloat(raw);
  };


  const handleChange = (e) => {
    const val = sanitize(e.target.value);
    dispatch({ type: 'UPDATE_DRAWER_COINS', payload: val });
  };
  

  const handleConfirm = () => {
    onNext();
  };
  

  return (
    <div className="p-4 max-w-md mx-auto bg-white rounded-2xl shadow-lg">
      <h2 className="text-2xl font-bold mb-4">Step: Drawer Coin Count</h2>

      <div className="mb-6">
        <label className="block mb-1">Drawer Coins Total ($):</label>
        <input
          type="number"
          min="0"
          step="0.01"
          value={drawerCoins}
          onChange={handleChange}
          onFocus={(e) => e.target.select()}
          className="border rounded p-1 w-24"
        />
      </div>

      <div className="flex justify-between">
        <button
          className="px-4 py-2 bg-gray-300 rounded"
          onClick={() => {
              onBack();
          }}
        >
          Back
        </button>
        <button
          className="px-4 py-2 bg-blue-500 text-white rounded"
          onClick={handleConfirm}
        >
          Confirm Drawer Coins
        </button>
      </div>
    </div>
  );
};

// explicit default export
export default DrawerCoinScreen;
